import SoonPlaceholder from 'components/utils/SoonPlaceholder';

export default function ConfigsPage() {
  return <SoonPlaceholder />;
}
